import { css, styled } from 'styled-components'

type StyledInputFieldWrapperProps = {
  $hasError: boolean
  $hasValue: boolean
  $isDisabled: boolean
  $isFocused: boolean
}

export const StyledInputFieldWrapper = styled.div<StyledInputFieldWrapperProps>`
  display: flex;
  width: 100%;
  height: 3.5rem;
  flex-direction: row;
  align-items: center;
  padding: 0 1rem;
  border-radius: ${({ theme }) => theme.radius['Radius LG']}px;
  background-color: ${({ theme }) => theme.colors['N Surface/Primary']};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'initial' : 'text')};
  gap: 0.5rem;

  ${({ $hasError, $isDisabled, $isFocused, theme }) => {
    if ($hasError) {
      return css`
        border: 1px solid ${theme.colors['N Outline/Error']};
      `
    }
    if ($isDisabled) {
      return css`
        border: 1px solid ${theme.colors['N Surface/Primary']};
      `
    }
    if ($isFocused) {
      return css`
        border: 1px solid ${theme.colors['N Outline/Brand Selected']};
      `
    }
    return css`
      border: 1px solid ${theme.colors['N Surface/Primary']};

      &:hover {
        border: 1px solid ${theme.colors['N Outline/Brand Hover']};
      }
    `
  }};
`

export const StyledInputField = styled.input`
  width: 100%;
  padding: 0;
  border: none;
  background-color: transparent !important;
  color: ${({ theme }) => theme.colors['N Content/Primary']};
  outline: none;
  transition: 0.1s ease-out;

  /* Removes autocomplete background */
  &:is(:-webkit-autofill, :autofill) {
    background-clip: text;
    -webkit-text-fill-color: ${({ theme }) =>
      theme.colors['N Content/Primary']} !important;
  }

  &[disabled] {
    color: ${({ theme }) => theme.colors['N Content/Disabled']};
  }
`
